export const environment = {
  production: false,
  // Configuration for MSAL (Microsoft Authentication Library)
  AUTH_CONFIG: {
    clientId: 'fc7209f1-109a-4972-a9c4-b31ec708f23c',
    authority:
      'https://login.microsoftonline.com/8d88c9c2-2058-486d-9cd4-2fc9010326bc',
    redirectUri: 'https://digitalupload-nonprod.ingredion.com/',
    postLogoutRedirectUri: 'https://digitalupload-nonprod.ingredion.com/',
    scopes: ['user.read'],
    dut_scope: ['api://dfc69497-8581-413d-a7e3-626cf633b5bf/access_as_user'],
  },
  // Configuration for the API
  API_CONFIG: {
    uri: 'https://graph.microsoft.com/v1.0/me',
    dut_scope: ['api://dfc69497-8581-413d-a7e3-626cf633b5bf/access_as_user'],
  },
  APP_BASE_URL: 'https://digitalupload-nonprod.ingredion.com/dutapi',
};
